"use strict";

angular.module('PatientApp').factory('BrowserInfoService', function (VuexStore) {
  return {
    openModal: function openModal() {
      try {
        VuexStore.state.AppStore.browserInfoCallback();
      } catch (e) {
        /* eslint-disable no-console */
        console.error('BrowserInfoService.openModal() was called before a callback method had been specified.');
        /* eslint-enable no-console */
      }
    },
    onOpenModal: function onOpenModal(_callback) {
      VuexStore.commit('setBrowserInfoCallback', _callback);
    },
    getIPData: function getIPData(successCallback, errorCallback) {
      return VuexStore.dispatch('getIPData', {
        successCallback: successCallback,
        errorCallback: errorCallback
      });
    }
  };
});